<template>
        <div class="px-8">
            <contract-invoice :invoice="invoice" :print="true"></contract-invoice>
        </div>
</template>

<script>

import ContractInvoice from "@/Components/CustomerContracts/ContractInvoice";

export default {
    components: {ContractInvoice},
    props: {
        invoice: {
            type: Object,
            default: {}
        },
    },
    mounted() {
        this.$eventBus.$emit('show-contract-invoice', this.invoice)
    }
}
</script>
